/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TableDefinitionsRouteRouteImport } from './routes/table-definitions/route'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TasksIndexRouteImport } from './routes/tasks/index'
import { Route as TableDefinitionsIndexRouteImport } from './routes/table-definitions/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as TasksIdRouteImport } from './routes/tasks/$id'
import { Route as TableDefinitionsNewRouteImport } from './routes/table-definitions/new'
import { Route as TableDefinitionsIdRouteImport } from './routes/table-definitions/$id'
import { Route as SettingsSourceSystemsRouteRouteImport } from './routes/settings/source-systems/route'
import { Route as SettingsAdminSettingsRouteRouteImport } from './routes/settings/admin-settings/route'
import { Route as SettingsSourceSystemsIndexRouteImport } from './routes/settings/source-systems/index'
import { Route as SettingsAdminSettingsIndexRouteImport } from './routes/settings/admin-settings/index'
import { Route as TableDefinitionsIdUploadRouteImport } from './routes/table-definitions/$id_/upload'
import { Route as SettingsSourceSystemsNewRouteImport } from './routes/settings/source-systems/new'
import { Route as SettingsSourceSystemsIdRouteImport } from './routes/settings/source-systems/$id'

const TableDefinitionsRouteRoute = TableDefinitionsRouteRouteImport.update({
  id: '/table-definitions',
  path: '/table-definitions',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => rootRouteImport,
} as any)
const TableDefinitionsIndexRoute = TableDefinitionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TableDefinitionsRouteRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const TasksIdRoute = TasksIdRouteImport.update({
  id: '/tasks/$id',
  path: '/tasks/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TableDefinitionsNewRoute = TableDefinitionsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => TableDefinitionsRouteRoute,
} as any)
const TableDefinitionsIdRoute = TableDefinitionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => TableDefinitionsRouteRoute,
} as any)
const SettingsSourceSystemsRouteRoute =
  SettingsSourceSystemsRouteRouteImport.update({
    id: '/source-systems',
    path: '/source-systems',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsAdminSettingsRouteRoute =
  SettingsAdminSettingsRouteRouteImport.update({
    id: '/admin-settings',
    path: '/admin-settings',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsSourceSystemsIndexRoute =
  SettingsSourceSystemsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SettingsSourceSystemsRouteRoute,
  } as any)
const SettingsAdminSettingsIndexRoute =
  SettingsAdminSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SettingsAdminSettingsRouteRoute,
  } as any)
const TableDefinitionsIdUploadRoute =
  TableDefinitionsIdUploadRouteImport.update({
    id: '/$id_/upload',
    path: '/$id/upload',
    getParentRoute: () => TableDefinitionsRouteRoute,
  } as any)
const SettingsSourceSystemsNewRoute =
  SettingsSourceSystemsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => SettingsSourceSystemsRouteRoute,
  } as any)
const SettingsSourceSystemsIdRoute = SettingsSourceSystemsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SettingsSourceSystemsRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteRouteWithChildren
  '/table-definitions': typeof TableDefinitionsRouteRouteWithChildren
  '/settings/admin-settings': typeof SettingsAdminSettingsRouteRouteWithChildren
  '/settings/source-systems': typeof SettingsSourceSystemsRouteRouteWithChildren
  '/table-definitions/$id': typeof TableDefinitionsIdRoute
  '/table-definitions/new': typeof TableDefinitionsNewRoute
  '/tasks/$id': typeof TasksIdRoute
  '/settings/': typeof SettingsIndexRoute
  '/table-definitions/': typeof TableDefinitionsIndexRoute
  '/tasks': typeof TasksIndexRoute
  '/settings/source-systems/$id': typeof SettingsSourceSystemsIdRoute
  '/settings/source-systems/new': typeof SettingsSourceSystemsNewRoute
  '/table-definitions/$id/upload': typeof TableDefinitionsIdUploadRoute
  '/settings/admin-settings/': typeof SettingsAdminSettingsIndexRoute
  '/settings/source-systems/': typeof SettingsSourceSystemsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/table-definitions/$id': typeof TableDefinitionsIdRoute
  '/table-definitions/new': typeof TableDefinitionsNewRoute
  '/tasks/$id': typeof TasksIdRoute
  '/settings': typeof SettingsIndexRoute
  '/table-definitions': typeof TableDefinitionsIndexRoute
  '/tasks': typeof TasksIndexRoute
  '/settings/source-systems/$id': typeof SettingsSourceSystemsIdRoute
  '/settings/source-systems/new': typeof SettingsSourceSystemsNewRoute
  '/table-definitions/$id/upload': typeof TableDefinitionsIdUploadRoute
  '/settings/admin-settings': typeof SettingsAdminSettingsIndexRoute
  '/settings/source-systems': typeof SettingsSourceSystemsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteRouteWithChildren
  '/table-definitions': typeof TableDefinitionsRouteRouteWithChildren
  '/settings/admin-settings': typeof SettingsAdminSettingsRouteRouteWithChildren
  '/settings/source-systems': typeof SettingsSourceSystemsRouteRouteWithChildren
  '/table-definitions/$id': typeof TableDefinitionsIdRoute
  '/table-definitions/new': typeof TableDefinitionsNewRoute
  '/tasks/$id': typeof TasksIdRoute
  '/settings/': typeof SettingsIndexRoute
  '/table-definitions/': typeof TableDefinitionsIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/settings/source-systems/$id': typeof SettingsSourceSystemsIdRoute
  '/settings/source-systems/new': typeof SettingsSourceSystemsNewRoute
  '/table-definitions/$id_/upload': typeof TableDefinitionsIdUploadRoute
  '/settings/admin-settings/': typeof SettingsAdminSettingsIndexRoute
  '/settings/source-systems/': typeof SettingsSourceSystemsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/table-definitions'
    | '/settings/admin-settings'
    | '/settings/source-systems'
    | '/table-definitions/$id'
    | '/table-definitions/new'
    | '/tasks/$id'
    | '/settings/'
    | '/table-definitions/'
    | '/tasks'
    | '/settings/source-systems/$id'
    | '/settings/source-systems/new'
    | '/table-definitions/$id/upload'
    | '/settings/admin-settings/'
    | '/settings/source-systems/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/table-definitions/$id'
    | '/table-definitions/new'
    | '/tasks/$id'
    | '/settings'
    | '/table-definitions'
    | '/tasks'
    | '/settings/source-systems/$id'
    | '/settings/source-systems/new'
    | '/table-definitions/$id/upload'
    | '/settings/admin-settings'
    | '/settings/source-systems'
  id:
    | '__root__'
    | '/'
    | '/settings'
    | '/table-definitions'
    | '/settings/admin-settings'
    | '/settings/source-systems'
    | '/table-definitions/$id'
    | '/table-definitions/new'
    | '/tasks/$id'
    | '/settings/'
    | '/table-definitions/'
    | '/tasks/'
    | '/settings/source-systems/$id'
    | '/settings/source-systems/new'
    | '/table-definitions/$id_/upload'
    | '/settings/admin-settings/'
    | '/settings/source-systems/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  TableDefinitionsRouteRoute: typeof TableDefinitionsRouteRouteWithChildren
  TasksIdRoute: typeof TasksIdRoute
  TasksIndexRoute: typeof TasksIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/table-definitions': {
      id: '/table-definitions'
      path: '/table-definitions'
      fullPath: '/table-definitions'
      preLoaderRoute: typeof TableDefinitionsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/table-definitions/': {
      id: '/table-definitions/'
      path: '/'
      fullPath: '/table-definitions/'
      preLoaderRoute: typeof TableDefinitionsIndexRouteImport
      parentRoute: typeof TableDefinitionsRouteRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/tasks/$id': {
      id: '/tasks/$id'
      path: '/tasks/$id'
      fullPath: '/tasks/$id'
      preLoaderRoute: typeof TasksIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/table-definitions/new': {
      id: '/table-definitions/new'
      path: '/new'
      fullPath: '/table-definitions/new'
      preLoaderRoute: typeof TableDefinitionsNewRouteImport
      parentRoute: typeof TableDefinitionsRouteRoute
    }
    '/table-definitions/$id': {
      id: '/table-definitions/$id'
      path: '/$id'
      fullPath: '/table-definitions/$id'
      preLoaderRoute: typeof TableDefinitionsIdRouteImport
      parentRoute: typeof TableDefinitionsRouteRoute
    }
    '/settings/source-systems': {
      id: '/settings/source-systems'
      path: '/source-systems'
      fullPath: '/settings/source-systems'
      preLoaderRoute: typeof SettingsSourceSystemsRouteRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/admin-settings': {
      id: '/settings/admin-settings'
      path: '/admin-settings'
      fullPath: '/settings/admin-settings'
      preLoaderRoute: typeof SettingsAdminSettingsRouteRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/source-systems/': {
      id: '/settings/source-systems/'
      path: '/'
      fullPath: '/settings/source-systems/'
      preLoaderRoute: typeof SettingsSourceSystemsIndexRouteImport
      parentRoute: typeof SettingsSourceSystemsRouteRoute
    }
    '/settings/admin-settings/': {
      id: '/settings/admin-settings/'
      path: '/'
      fullPath: '/settings/admin-settings/'
      preLoaderRoute: typeof SettingsAdminSettingsIndexRouteImport
      parentRoute: typeof SettingsAdminSettingsRouteRoute
    }
    '/table-definitions/$id_/upload': {
      id: '/table-definitions/$id_/upload'
      path: '/$id/upload'
      fullPath: '/table-definitions/$id/upload'
      preLoaderRoute: typeof TableDefinitionsIdUploadRouteImport
      parentRoute: typeof TableDefinitionsRouteRoute
    }
    '/settings/source-systems/new': {
      id: '/settings/source-systems/new'
      path: '/new'
      fullPath: '/settings/source-systems/new'
      preLoaderRoute: typeof SettingsSourceSystemsNewRouteImport
      parentRoute: typeof SettingsSourceSystemsRouteRoute
    }
    '/settings/source-systems/$id': {
      id: '/settings/source-systems/$id'
      path: '/$id'
      fullPath: '/settings/source-systems/$id'
      preLoaderRoute: typeof SettingsSourceSystemsIdRouteImport
      parentRoute: typeof SettingsSourceSystemsRouteRoute
    }
  }
}

interface SettingsAdminSettingsRouteRouteChildren {
  SettingsAdminSettingsIndexRoute: typeof SettingsAdminSettingsIndexRoute
}

const SettingsAdminSettingsRouteRouteChildren: SettingsAdminSettingsRouteRouteChildren =
  {
    SettingsAdminSettingsIndexRoute: SettingsAdminSettingsIndexRoute,
  }

const SettingsAdminSettingsRouteRouteWithChildren =
  SettingsAdminSettingsRouteRoute._addFileChildren(
    SettingsAdminSettingsRouteRouteChildren,
  )

interface SettingsSourceSystemsRouteRouteChildren {
  SettingsSourceSystemsIdRoute: typeof SettingsSourceSystemsIdRoute
  SettingsSourceSystemsNewRoute: typeof SettingsSourceSystemsNewRoute
  SettingsSourceSystemsIndexRoute: typeof SettingsSourceSystemsIndexRoute
}

const SettingsSourceSystemsRouteRouteChildren: SettingsSourceSystemsRouteRouteChildren =
  {
    SettingsSourceSystemsIdRoute: SettingsSourceSystemsIdRoute,
    SettingsSourceSystemsNewRoute: SettingsSourceSystemsNewRoute,
    SettingsSourceSystemsIndexRoute: SettingsSourceSystemsIndexRoute,
  }

const SettingsSourceSystemsRouteRouteWithChildren =
  SettingsSourceSystemsRouteRoute._addFileChildren(
    SettingsSourceSystemsRouteRouteChildren,
  )

interface SettingsRouteRouteChildren {
  SettingsAdminSettingsRouteRoute: typeof SettingsAdminSettingsRouteRouteWithChildren
  SettingsSourceSystemsRouteRoute: typeof SettingsSourceSystemsRouteRouteWithChildren
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsAdminSettingsRouteRoute: SettingsAdminSettingsRouteRouteWithChildren,
  SettingsSourceSystemsRouteRoute: SettingsSourceSystemsRouteRouteWithChildren,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

interface TableDefinitionsRouteRouteChildren {
  TableDefinitionsIdRoute: typeof TableDefinitionsIdRoute
  TableDefinitionsNewRoute: typeof TableDefinitionsNewRoute
  TableDefinitionsIndexRoute: typeof TableDefinitionsIndexRoute
  TableDefinitionsIdUploadRoute: typeof TableDefinitionsIdUploadRoute
}

const TableDefinitionsRouteRouteChildren: TableDefinitionsRouteRouteChildren = {
  TableDefinitionsIdRoute: TableDefinitionsIdRoute,
  TableDefinitionsNewRoute: TableDefinitionsNewRoute,
  TableDefinitionsIndexRoute: TableDefinitionsIndexRoute,
  TableDefinitionsIdUploadRoute: TableDefinitionsIdUploadRoute,
}

const TableDefinitionsRouteRouteWithChildren =
  TableDefinitionsRouteRoute._addFileChildren(
    TableDefinitionsRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  TableDefinitionsRouteRoute: TableDefinitionsRouteRouteWithChildren,
  TasksIdRoute: TasksIdRoute,
  TasksIndexRoute: TasksIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
